__turbopack_context__.v({
  "arrow": "TasksHeroBanners-module-scss-module__jijE2q__arrow",
  "arrowPrev": "TasksHeroBanners-module-scss-module__jijE2q__arrowPrev",
  "arrows": "TasksHeroBanners-module-scss-module__jijE2q__arrows",
  "bar": "TasksHeroBanners-module-scss-module__jijE2q__bar",
  "barActive": "TasksHeroBanners-module-scss-module__jijE2q__barActive",
  "bars": "TasksHeroBanners-module-scss-module__jijE2q__bars",
  "content": "TasksHeroBanners-module-scss-module__jijE2q__content",
  "controls": "TasksHeroBanners-module-scss-module__jijE2q__controls",
  "cta": "TasksHeroBanners-module-scss-module__jijE2q__cta",
  "ctaIcon": "TasksHeroBanners-module-scss-module__jijE2q__ctaIcon",
  "ctaRow": "TasksHeroBanners-module-scss-module__jijE2q__ctaRow",
  "description": "TasksHeroBanners-module-scss-module__jijE2q__description",
  "image": "TasksHeroBanners-module-scss-module__jijE2q__image",
  "media": "TasksHeroBanners-module-scss-module__jijE2q__media",
  "note": "TasksHeroBanners-module-scss-module__jijE2q__note",
  "pageTitle": "TasksHeroBanners-module-scss-module__jijE2q__pageTitle",
  "root": "TasksHeroBanners-module-scss-module__jijE2q__root",
  "slide": "TasksHeroBanners-module-scss-module__jijE2q__slide",
  "sponsor": "TasksHeroBanners-module-scss-module__jijE2q__sponsor",
  "sponsorLink": "TasksHeroBanners-module-scss-module__jijE2q__sponsorLink",
  "sponsorLogo": "TasksHeroBanners-module-scss-module__jijE2q__sponsorLogo",
  "statIcon": "TasksHeroBanners-module-scss-module__jijE2q__statIcon",
  "stats": "TasksHeroBanners-module-scss-module__jijE2q__stats",
  "swiper": "TasksHeroBanners-module-scss-module__jijE2q__swiper",
  "title": "TasksHeroBanners-module-scss-module__jijE2q__title",
});
